module.exports = __webpack_public_path__ + "static/Privacystatement-NOM_v2026-09-01-4032728d8c7d8b89a96e33c3c718a575.pdf";